export default __webpack_public_path__ + "static/media/Domain.86e43d09.svg";